angular.module("digitalLeasing.module")
  .component("quoteNotes", {
    templateUrl: "ng/components/digitalLeasing/financialData/quoteNotes/quoteNotes.view.html",
    bindings: {
      model: "=",
      onQuoteNotesChange: "&?",
      checkComponent: '&',
      callCheck: '<',
      leasindDataId: '<'
    },
    controllerAs: "quoteNotesCtrl",
    controller: QuoteNotesController
  });

function QuoteNotesController(
  FileUploader,
  $simulationService,
  $configService,
  $rootScope,
  $timeout,
  $financialApiService,
  $download
) {

  var self = this;

  self.$onInit = function () {
    console.log(self.model);
	
	//RN:12255567 - Slim Leasing
	//Check per vedere se il documento slim leasing e uploadato
	checkSlimLeasing();
	
    checkPage();
    self.loadingStatus = {
      uploading: false
    };

    self.showRestrictedFiles = $configService.getAppConfig().allFunctionalities.includes("DOC_RISERVATI");
  }

  self.$onChanges = function (change) {
    if (change.callCheck && typeof change.callCheck.currentValue != 'undefined') {
      checkPage();
    }
  }

  self.handleQuoteChange = function (value) {
    checkPage();
    // self.model[value] = self.model[value] && self.model[value].replace(/[\u0000-\u001f]/gi, '');
    // self.model[value] = self.model[value] && self.model[value].replace(/[\u0080-\u009f]/gi, '');
    // self.model[value] = self.model[value] && self.model[value].replace(/[\u0100-\uffff]/gi, '');
  }
  
  var checkSlimLeasing = function() {
	//RN:12255567 - Slim Leasing
	//Check per vedere se il documento slim leasing e uploadato
	self.documentoSlimLeasingUploadato = false;
	if(self.model.allegati && self.model.allegati.length > 0) {
		self.model.allegati.forEach(allegato => {
		  if (allegato.documentoSlimLeasing === true) {
		    self.documentoSlimLeasingUploadato = true;
		  }
		});
	}
  }

  var checkPage = function () {
    var test = false;
    if (self.model.pianoFinanziario.provvigioni.forzate) {
      var test = !!self.model.noteAlba
    } else {
      test = true;
    }
	
	//RN:12255567 - Slim Leasing
	//Check per vedere se il documento slim leasing e uploadato
	if(test && self.model.slimLeasing) {
		test = self.documentoSlimLeasingUploadato;
	}
	
    if (test) {
      self.checkComponent({
        value: true
      })
    } else {
      self.checkComponent({
        value: false
      })
    }
  }

  self.check = function (el) {
    el.isSelected = !el.isSelected;
  };

  // inizio procedura upload file
  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName
    }
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ?
        arguments[3] :
        false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;

    self.restricted = arguments.length > 2 && arguments[2] !== undefined ?
      arguments[2] : false;
    
    self.documentoSlimLeasing = arguments.length > 4 && arguments[4] !== undefined ?
      arguments[4] : false;

  };



  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    var url = $configService.getAppConfig().url +
      "/uni/upload/service-infos/" +
      encodeURIComponent(self.model.anno) +
      "/" +
      encodeURIComponent(self.model.numero) +
      "/FINANCIAL";

    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var file = {}
    if (self.documentoSlimLeasing) {
    	file = document.querySelector("#uploadInput_document_documentoSlimLeasing").files[0];
    } else if (self.restricted) {
    	file = document.querySelector("#uploadInput_document_restrict").files[0];
    } else {
    	file = document.querySelector("#uploadInput_document").files[0];
    }

    self.disabledButtonUpload = true;
    var reader = new FileReader();
	var cdDocCorretto = "GENP";
	var typeCorretto = "FINANCIAL_DEROGHE";
	
    reader.onload = function (event) {
      if(self.documentoSlimLeasing) {
    	  jQuery("#uploadInput_document_documentoSlimLeasing").val("");
		  cdDocCorretto = "077";
		  //typeCorretto = "DOCREPO";
      } else if (self.restricted) {
    	  jQuery("#uploadInput_document_restrict").val("");
		  cdDocCorretto = "GENP";
		  typeCorretto = "FINANCIAL_DEROGHE";
      } else {
    	  jQuery("#uploadInput_document").val("");
		  cdDocCorretto = "GENP";
		  typeCorretto = "FINANCIAL_DEROGHE";
      }
      var formData = new FormData();
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", typeCorretto);
      appendToForm(formData, "cdDoc", cdDocCorretto);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.leasindDataId);
      appendToForm(formData, "restricted", self.restricted);
      appendToForm(formData, "documentoSlimLeasing", self.documentoSlimLeasing);

      $financialApiService.uploadDocOnDigital(formData)
        .then(function (response) {

          $timeout(function () {
            var tmp = {
              filename: file.name,
              id: response.id,
              cdDoc: cdDocCorretto,
              status: "1",
              downloadKey: response.downloadKey,
              restricted: self.restricted,
              documentoSlimLeasing: self.documentoSlimLeasing
            }

            if(self.documentoSlimLeasing) {
            	self.documentoSlimLeasingUploadato = true;
				checkPage();
            }
            
            self.visualProgBarDoc = false;
            self.model.allegati.push(tmp);
            self.disabledButtonUpload = false;
          }, 4000);
        })
        .catch(function (error) {
          self.visualProgBarDoc = false;
          self.disabledButtonUpload = false;
        })
    };
    if (file) {
      reader.readAsArrayBuffer(file);
    }
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED"
      });
      fileItem.remove();
      if(self.documentoSlimLeasing) {
    	  jQuery("#uploadInput_document_documentoSlimLeasing").val("");  
      } else if (self.restricted) {
    	  jQuery("#uploadInput_document_restrict").val("");
      } else {
    	  jQuery("#uploadInput_document").val("");
      }
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".msg") > -1 ||
      fileName.toLowerCase().indexOf(".eml") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1
    ) {

      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      if(self.documentoSlimLeasing) {
    	  jQuery("#uploadInput_document_documentoSlimLeasing").val("");  
      } else if (self.restricted) {
    	  jQuery("#uploadInput_document_restrict").val("");
      } else {
    	  jQuery("#uploadInput_document").val("");
      }
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED"
      });

    }
  };

  //altre funzioni di upload
  self.generateDownloadLink = function (file) {

    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })

  }
  self.uploader.onWhenAddingFileFailed = function (
    item,
    filter,
    options
  ) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {

    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;

  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    self.disabledButtonUpload = false;
    if(self.documentoSlimLeasing) {
  	  jQuery("#uploadInput_document_documentoSlimLeasing").val("");  
    } else if (self.restricted) {
  	  jQuery("#uploadInput_document_restrict").val("");
    } else {
  	  jQuery("#uploadInput_document").val("");
    }

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE"
    });

    $timeout(function () {

      self.visualProgBarDoc = false;


    }, 4000);

    fileItem.remove();
    if(self.documentoSlimLeasing) {
  	  jQuery("#uploadInput_document_documentoSlimLeasing").val("");  
    } else if (self.restricted) {
  	  jQuery("#uploadInput_document_restrict").val("");
    } else {
  	  jQuery("#uploadInput_document").val("");
    }

  };

  self.uploader.onCancelItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.log(status);
    self.disabledButtonUpload = false;
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (response && response.uploadFileServicePojo && response.uploadFileServicePojo.success) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: ""
      };

      self.listOfFilesUpload = response.metadataUniUpload.uploadedfile
        .sort(function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1
          } else {
            return -1
          }
        });
    }
    self.uploader.queue = [];

    $timeout(function () {

      self.visualProgBarDoc = false;


    }, 4000);
    jQuery("#uploadInput_document").val("");


  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deleteDocument = function (restricted, documentoSlimLeasing) {
    self.restricted = restricted;
    self.documentoSlimLeasing = documentoSlimLeasing;
    
    if(documentoSlimLeasing) {
    	self.documentoSlimLeasingUploadato = false;
		checkPage();
    }
    
    self.visualProgBarDoc = true;
    var temp = self.model.allegati
      .filter(function (element) {
        return element.isSelected == true;
      })

    temp.forEach(function (element) {


      $simulationService.deleteChecklistFileDigital(element.id)
        .then(function (response) {
          console.log(response);

          self.progresso = 0;
          $timeout(function () {
            self.visualProgBarDoc = false;
          }, 4000);

          $timeout(function () {
            self.model.allegati = self.model.allegati
              .filter(function (elem) {
                return elem.isSelected != true;
              })
          }, 3500);
        })
        .catch(function (error) {
          $rootScope.$broadcast('addAlert', {
            text: 'ERROR_TEC'
          });
        });

    });
  }

  //fine procedura upload

}